import Bowser from 'bowser';

import {
  ipadUnsupportedBrowsers,
  unsupportedBrowsers,
} from 'constants/unsupportedBrowsers';
import { ensureString } from 'utils/string';

// https://stackoverflow.com/questions/8348139/detect-ios-version-less-than-5-with-javascript/14223920#14223920
const iOSVersion = () => {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
    const v = ensureString(navigator?.appVersion).match(
      /OS (\d+)_(\d+)_?(\d+)?/,
    );
    if (v) {
      return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
    return undefined;
  }
  return undefined;
};

export const updateDeviceInfo = () => async dispatch => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const userDeviceInfo = Bowser.parse(window.navigator.userAgent);
  const usingIpad = window.navigator.userAgent.match(/iPad/i) != null;
  const isUnsupported = usingIpad
    ? browser.satisfies(ipadUnsupportedBrowsers)
    : browser.satisfies(unsupportedBrowsers);
  const usingSafari = browser.getBrowserName() === 'Safari';
  const iOS = userDeviceInfo.os.name === 'iOS';
  const chromeOS = userDeviceInfo.os.name === 'Chrome OS';
  const isMobileDevice = userDeviceInfo.platform.type === 'mobile';
  const isTabletDevice = userDeviceInfo.platform.type === 'tablet';
  // bowser only accounts for macOS, windows, and linux when checking if the platform is desktop
  const isDesktopDevice =
    userDeviceInfo.platform.type === 'desktop' || chromeOS;
  const deviceInfo = {
    isUnsupported,
    usingSafari,
    iOS,
    iOSVersion: iOSVersion(),
    isMobileDevice,
    isTabletDevice,
    isDesktopDevice,
  };

  dispatch({
    type: 'USER_DEVICE/UPDATE_DEVICE_INFO',
    deviceInfo,
  });
};

export default updateDeviceInfo;

export const isIPad =
  navigator.userAgent.match(/Mac/) && navigator?.maxTouchPoints > 2;
